import React from "react";

import { FollowingList } from "../../../components/admin/u1/following/FollowingList";
import { StateLegend, CLAIMED_STEPS } from "../../../components/common/static/u1/StateLegend";
import { OwnerCard } from "../../../components/common/static/u1/OwnerCard";
import { ResearcherCard } from "../../../components/common/static/u1/ResearcherCard";
import "../../../components/common/u1/tokens.css";

/* u1 Following — TIP-640.
 *
 * Visual uplift only. The list's data handling is transcribed in
 * FollowingList; the rail reuses the static cards the other dashboard screens
 * already have, so there is one copy of each.
 *
 * The legend drops its "Listed" step here: a business you follow has at least
 * been claimed by the time it has updates worth following, so Claimed and
 * Verified are the two badges this screen can actually show.
 */
export default function Following() {
  return (
    <div className="u1-root grid grid-cols-1 items-start gap-[22px] pt-5 sm:pt-[26px] pb-6 lg:grid-cols-[minmax(0,1fr)_340px]">
      <div className="min-w-0">
        <FollowingList />
      </div>

      <aside className="flex min-w-0 flex-col gap-4">
        <StateLegend
          eyebrow="Reading your companies"
          steps={CLAIMED_STEPS}
          intro="Every business you follow has one status. It shows how far it has come on TREVEX."
        />
        <OwnerCard />
        <ResearcherCard />
      </aside>
    </div>
  );
}
